import React from 'react';

export const LeaderboardSponsorLogo = () => {
  const styles = {
    logo: {
      height: 90, 
      width: 200,
      display: 'block',
      backgroundImage: `url("/wp-content/themes/HighendWP/react-templates-apps/leaderboards/src/assets/images/leaderboard-sponsor-white.png")`,
      backgroundSize: 'contain',
      margin: '0 auto',
      content: '',
      zIndex: 9,
      lineHeight: 0, 
      fontSize: 0,
      color: 'transparent',
    }
  }

  return (
      <a target="_blank" rel="noreferrer"  href="https://www.wrangler.com/" style={styles.logo}>sponsor logo</a>
  )
}
